import React, {Component} from "react"
import PropTypes from "prop-types"

import {Card} from "semantic-ui-react"
import shop from "shop/shop"

let instanceIndex = 0

class ProductSearch extends Component {

  constructor( props ) {
    super( props )
    this.state = {
      products: [],
    }
    instanceIndex++
  }

  componentWillReceiveProps( props ) {
    if ( props !== this.props ) {
      this.load( props )
    }
  }

  componentDidMount() {
    this.load( this.props )
  }

  load( { cats, query } ) {
    // API bottleneck
    window.setTimeout( () => {
        if ( cats.length > 0 ) this.loadFromCategories( cats, query )
        if ( cats.length === 0 ) this.loadSearch( query )
      },
      5 * instanceIndex
    )
  }

  loadSearch( query ) {
    this.lastQuery = { query }
    shop.products.search( query, {
      count: this.props.count,
      page: 1
    } )
      .then( this.handleProducts )
  }

  loadFromCategories( cats, query ) {
    console.log('load cat top seller');
    this.lastQuery = { cats, query }
    shop.products.fromCategory( cats, {
      count: this.props.count || 4, page: 1, query, sort: 'topseller'
    } )
      .then( this.handleProducts )
  }

  handleProducts = ( response ) => {
    let { products } = response
    if ( !products ) return
    this.setState( { products } )

    if ( this.props.onload ) {
      this.props.onload( response )
    }
  }

  render() {
    let Child = this.props.repeat
    let { title } = this.props
    let products = this.state.products.map( product => <Child key={product.map_id}
                                                              product={product}/> )

    if ( products.length === 0 ) {
      return null
    }
    return (
      <div key={this.props.key}>
        {(title) ? <div className="row-title"><h2>{title}</h2></div> : null}
        <Card.Group itemsPerRow="4">
          {products}
        </Card.Group>
      </div>
    )
  }
}

ProductSearch.defaultProps = {
  count: 4, start: 0, query: "%%", cats: [], sort: 'topseller'
}

ProductSearch.propTypes = {
  title:  PropTypes.string,
  count:  PropTypes.number,
  page:   PropTypes.number,
  query:  PropTypes.string,
  cats:   PropTypes.oneOfType( [
    PropTypes.array,
    PropTypes.string
  ] ),
  filter: PropTypes.object,
  onload: PropTypes.func,
  repeat: PropTypes.any.isRequired
}

export default ProductSearch



// WEBPACK FOOTER //
// ./src/theme/mags/components/Product/ProductSearch.js